import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import NewRelicService from '@Services/NewRelicService';

export const TIMEOUT = 4000;
export const ERROR_MSG = 'This is taking longer than expected.';

function PageLoadingTimeout() {
  const [isShown, setIsShown] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setIsShown(true);

      // Send NR error
      const error = new Error(ERROR_MSG);
      NewRelicService.noticeError(error);
    }, TIMEOUT);

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <div className={cn('page-loading-timeout', { 'page-loading-timeout--hidden': !isShown })}>
      <div className="page-loading-timeout__message u-els-background-color-background u-els-padding u-els-text-center">
        <div className="u-els-margin-bottom-1o2">{ERROR_MSG}</div>
        <div>You might need to refresh the page or try again later.</div>
      </div>
    </div>
  );
}

export default PageLoadingTimeout;
